import React, { FC } from 'react';
import classNames from 'classnames/bind';
import Slider from 'react-slick';
import properties from '../../../../../../modules/ajio-util/properties';
import UpcomingEventCard from '../../mobile/UpcomingEventCard';
import styles from './index.pcss';
import './index.scss';
import { replaceWithJioCDN } from '../../../../../../utils/imageHandling';

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const imageBaseUrl: string = properties.getProperty('imageBaseUrl');
const left = `${imageBaseUrl}/static/img/Chevron_Left_Shopper.svg`;
const right = `${imageBaseUrl}/static/img/Chevron_Right_Shopper.svg`;
const cx = classNames.bind(styles);

interface Slot {
  timeInterval: string;
  startTime: number;
  endTime: number;
  date: string;
}
interface Offer {
  label: string;
  description: string;
  bannerImageURL: string;
}
interface User {
  name: string;
  mobile: string;
  uuid: string;
  rank: number;
}
interface UpcomingEventData {
  slot?: Slot;
  offer?: Offer;
  userList?: User[];
}
interface UpcomingEventProps {
  variant?: string;
  data?: UpcomingEventData[];
}

const Arrow = ({ onClick, imageUrl, className, alt }): JSX.Element => {
  return (
    <div className={cx('slick-Image', className)}>
      <img role="presentation" src={replaceWithJioCDN(imageUrl)} alt="arrowKey" onClick={onClick} />
    </div>
  );
  // return <Icon icon={icon} iconClass={cx('slick-arrow', className)} onClick={onClick} />;
};

const slickSettings = {
  dots: false,
  arrows: true,
  swipe: false,
  swipeToSlide: false,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 3,
  nextArrow: <Arrow imageUrl={right} alt="Right arrow" className="arrow-right" />,
  prevArrow: <Arrow imageUrl={left} alt="Left arrow" className="arrow-left" />
};

const getUpcomingEventsDom = (variant: string, data: UpcomingEventData[]): JSX.Element => {
  return (
    <div className={cx('slick-slider', 'slick-root')}>
      <Slider {...slickSettings}>
        {data.map((eventItem, index) => {
          const { offer, slot } = eventItem;
          const { date, timeInterval, startTime, endTime } = slot;
          const { bannerImageURL, description, label } = offer;
          return (
            <div className={cx('event-card-container')} id={date}>
              <UpcomingEventCard
                key={index}
                imgSrc={bannerImageURL}
                rewardTitle={description}
                rewardDesc={label}
                date={date}
                timer={timeInterval}
                startTime={startTime}
                endTime={endTime}
              />
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

const UpcomingEvent: FC<UpcomingEventProps> = ({ variant, data }): JSX.Element => {
  return <>{getUpcomingEventsDom(variant, data)}</>;
};

export default UpcomingEvent;
